import { getOtherOptionsFromWindow } from "./getOtherOptionsFromWindow";
/**
 * Checks if the current page is customize page.
 */

function isCustomize() {
  return !!getOtherOptionsFromWindow().customizeIdsBanner;
}

export { isCustomize };